import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <div className="flex h-full items-center justify-center p-8">
      <div className="max-w-md text-center space-y-3">
        <p className="text-small uppercase tracking-wide text-muted-foreground">404</p>
        <h1 className="text-h2 font-semibold">Seite nicht gefunden</h1>
        <p className="text-body text-muted-foreground">
          Die angeforderte Seite existiert nicht oder wurde verschoben.
        </p>
        <Link to="/" className="text-accent hover:underline">
          Zurück zur Startseite
        </Link>
      </div>
    </div>
  )
}
